import { R } from '@utils/currency'
import { convertAssetCurrencyToZar } from '@utils/assets'

export const formatValuesForDisplay = (value, currency, supportedCurrencies) => {
  const convertedValue = convertAssetCurrencyToZar(value, supportedCurrencies[currency])
  const formattedValue = R(convertedValue).format()

  return formattedValue
}

